import Backend from "./backend";
import Loader from "./resources/js-simple-loader/loader.js"
import {Box} from "./resources/js-validation-notification/validation.functions.js"

const modalidades = [
    {
        nome: "Beach Tennis",
        alternate: "BEACH TENNIS",
        image: "http://posto011.com.br/wp-content/uploads/2024/04/image-1.png",
    },
    {
        nome: "Futevôlei",
        alternate: "FUTEVOLEI",
        image: "http://posto011.com.br/wp-content/uploads/2024/04/page-futvolei2-2.png",
    },
    {
        nome: "Vôlei de Praia",
        alternate: "VOLEI",
        image: "http://posto011.com.br/wp-content/uploads/2024/04/page-volei-praia2-21.png",
    }
]

var timesPassed = [];

export const Service = {
    branch: null,
    unidades: [],
    googleMapsAPIKey: "AIzaSyB2sPFpXnUcjZ3gdXuHrCFhoD50nZtGa3w",
    userHasSubmitted: () => {
        if (/enrollScheduled/.test(document.cookie)) {
            return JSON.parse(Service.getCookie("enrollScheduled"));
        }
        return false;
    },
    setCookie: function (name, value, date) {
        var expires = "";
        expires = "; expires=" + new Date(date).toUTCString();
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
    getCookie: function (name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    validate: (data) => {
        let lock = false;
        let required = ["nome", "email", "cpf", "modalidade", "telefone", "unidade"];
        required.forEach(req => {
            if (typeof data[req] === "undefined") {
                console.log('Não informado: ' + req);
                lock = true;
            }
        });
        if (lock) {
            console.log(data);
            return false;
        }
        lock = false;
        if (!data.nome.includes(" ")) {
            lock = true;
        }
        data.telefone = data.telefone.replace(/[^0-9]/g, "");
        if (data.telefone.length < 8) {
            lock = true;
        }
        data.cpf = data.cpf.replace(/[^0-9]+/g, "");
        if (data.cpf.length < 11) {
            lock = true;
        }
        if (lock) {
            return false;
        }
        return data;
    },
    setBranch: (branch) => {
        Service.branch = branch.normalize('NFD').replaceAll("ã", "a").toUpperCase();
    },
    setCalendarTime: (event, array) => {
        //for (var i = 0; i < 4; i++) {
        for (var i = 0; i < 3; i++) {
            let aux = event.startTime.split(":");
            //aux[1] = (i === 0 ? "00" : (i === 1 ? "15" : (i === 2 ? "30" : "45")));
            aux[1] = (i === 0 ? "00" : (i === 1 ? "20" : 40));
            let stringStart = event.activityDate.split("T")[0] + "T" + aux.join(":") + ":00";
            if (!array.includes(stringStart)) {
                array.push(stringStart);
                //return { start: new Date(stringStart), end: new Date(new Date(stringStart).getTime() + 15 * 60000) }
                return { start: new Date(stringStart), end: new Date(new Date(stringStart).getTime() + 20 * 60000) }
            }
        }
        let stringStart = event.activityDate.split("T")[0] + "T" + event.startTime + ":00";
        //return { start: new Date(stringStart), end: new Date(new Date(stringStart).getTime() + 15 * 60000) }
        return { start: new Date(stringStart), end: new Date(new Date(stringStart).getTime() + 20 * 60000) }
    },
    filterActivities: (activities) => {
        activities = activities.map(activity => {
            activity.startString = activity.startTime.split(":").join("h") + " " + activity.activityDate.split("T")[0].split("-").reverse().join("/");
            modalidades.forEach(modalidade => {
                if (modalidade.alternate === "VOLEI") {
                    if (activity.name.includes(modalidade.alternate) && !activity.name.includes('FUTE')) {
                        activity = { ...activity, title: modalidade.nome, refer: modalidade.nome };
                    }
                } else {
                    if (activity.name.includes(modalidade.alternate)) {
                        activity = { ...activity, title: modalidade.nome, refer: modalidade.nome };
                    }
                }
            });
            if (activity.status >= 6 || activity.ocupation === null || activity.capacity === null || (activity.ocupation !== null && activity.capacity !== null && activity.ocupation === activity.capacity)) {
                activity.title = "Turma fechada";
            }
            if (!activity.hasOwnProperty("idActivity")) {
                activity.title = "Turma fechada"
            }
            return activity;
        });
        activities = activities.filter(activity => typeof activity.refer !== "undefined")
        activities = activities.map(activity => {
            let calendarTime = Service.setCalendarTime(activity, timesPassed);
            activity.start = calendarTime.start;
            activity.end = calendarTime.end;
            let dateNow = new Date();
            dateNow.setTime(dateNow.getTime() + (1000 * 60 * 60 * 4));
            if (activity.start && activity.start.getTime() <= dateNow.getTime()) {
                activity.title = "Turma fechada"
            }
            return activity
        });
        return activities
    },
    getActivities: async (customDate = false) => {
        Loader.open();
        timesPassed = [];
        let activities = await Backend.call("/?path=/activities/schedule?showFullWeek=true&branch=" + Service.branch)
        if (activities === "") {
            return Service.getActivities();
        }
        let today = new Date();
        if (today.getDay() === 0) {
            Loader.close();
            return Service.filterActivities(activities);
        }
        let daysToAdd = (7 - today.getDay());
        let sunday = new Date();
        sunday.setDate(today.getDate() + daysToAdd);
        let nextActivities = await Backend.call("/?path=/activities/schedule?showFullWeek=true&date=" + sunday.toLocaleDateString().split("/").reverse().join("-") + "&branch=" + Service.branch);
        let nextDates = [];
        for (var i = 0; i < today.getDay(); i++) {
            let d = new Date();
            d.setDate(sunday.getDate() + i);
            nextDates.push(d.toLocaleDateString().split("/").reverse().join('-'));
        }
        nextActivities = nextActivities.filter(na => {
            let nad = na.activityDate.split("T")[0];
            return nextDates.includes(nad);
        });
        Loader.close();
        return Service.filterActivities([...activities, ...nextActivities]);
    },
    getMember: async (data) => {
        Loader.open();
        let user = await Backend.call("/?path=/members/basic?email=" + data.email + "&branch=" + Service.branch);
        if (!user || user.length === 0) {
            user = await Backend.call("/?path=/members/basic?document=" + data.cpf + "&branch=" + Service.branch);
        }

        Loader.close();
        return user;
    },
    getProspect: async (data) => {
        Loader.open();
        let user = await Backend.call("/?path=/prospects?email=" + data.email + "&branch=" + Service.branch);
        if (!user || user.length === 0) {
            user = await Backend.call("/?path=/prospects?document=" + data.cpf + "&branch=" + Service.branch);
        }
        Loader.close();
        return user;
    },
    getUser: async (data) => {
        Loader.open();
        let user = await Backend.call("/?path=/members/basic?email=" + data.email + "&branch=" + Service.branch);

        if (!user || user.length === 0) {
            user = await Backend.call("/?path=/members/basic?document=" + data.cpf + "&branch=" + Service.branch);
        }
        if (!user || user.length === 0) {
            user = await Backend.call("/?path=/prospects?email=" + data.email + "&branch=" + Service.branch);
        }
        if (!user || user.length === 0) {
            user = await Backend.call("/?path=/prospects?document=" + data.cpf + "&branch=" + Service.branch);
        }
        Loader.close();
        return user;
    },
    scheduleClass: async (data) => {
        Loader.open();
        let get = {
            idConfiguration: data.aulaExperimental.idConfiguration,
            activityDate: data.aulaExperimental.activityDate.split("T")[0] + " " + data.aulaExperimental.startTime,
            activityExist: "true",
            service: "AULA EXPERIMENTAL",
            activity: data.aulaExperimental.name
        };
        let body = {}
        if (data.user.hasOwnProperty("idMember")) {
            get['idMember'] = data.user[0].idMember;
        } else {
            get['idProspect'] = data.user[0].idProspect;
        }
        body['user'] = data.user[0];
        body['userData'] = data.userData;
        body['aula'] = data.aulaExperimental;
        let experimental = await Backend.call("/?path=/activities/schedule/experimental-class&branch=" + Service.branch, { ...body, get: get });
        console.log(experimental);
        console.log(typeof experimental);
        if (experimental !== null && typeof experimental === "object" && !experimental.hasOwnProperty('errors')) {
            data['sucesso'] = true;
            Loader.close();
            Box({
                title: "Sucesso!",
                messages: "Sua aula foi agendada!",
                buttons: { ok: "Ok" },
                actions: { ok: b => b.close() }
            });
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: "schedule-enroll", data: data });
            Service.setCookie("enrollScheduled", JSON.stringify(data), data.aulaExperimental.activityDate);
            return data;
        }
        Loader.close();
        console.log("Ops, tivemos um problema ao agendar sua aula...");
        console.log(experimental)
        const messages = {
            sessao: "A presença já está confirmada ou não há mais vagas disponíveis.",
        }
        let contains = experimental !== null && messages.hasOwnProperty(experimental?.errors[0].key);
        let messageError = experimental !== null && experimental?.errors[0]?.value;
        Box({
            title: "Ops...",
            messages: contains
                ? messages[experimental.errors[0].key]
                : messageError ?? "Tivemos um problema ao marcar agendar sua aula experimental.",
            //messages: "Tivemos um problema ao marcar agendar sua aula experimental.",
            buttons: { ok: "Ok" },
            actions: { ok: b => b.close() }
        });
        //return (contains ? { ...data, sucesso: true } : false);
        return false;

    },
    addUser: async (data) => {
        data = Service.validate(data)

        console.log(data);

        if (data) {
            let member = await Service.getMember(data);
            if (member.length > 0) {
                Loader.close();
                Box({
                    title: "Ops...",
                    messages: "Você já é um cliente do Posto 011, não é possível marcar uma aula experimental.",
                    buttons: { ok: "Ok" },
                    actions: { ok: b => b.close() }
                });
                return false;
            }

            let user = await Service.getProspect(data);
            if (user.length > 0) {
                Loader.close();
                Box({
                    title: "Ops...",
                    messages: "Você já fez uma aula experimental, não é possível marcar outra aula experimental, por favor, entrar em contato com nosso time de atendimento.",
                    buttons: { ok: "Ok" },
                    actions: { ok: b => b.close() }
                });
                return false;
            }

            let nome = data.nome.split(" ");
            if (user.length === 0) {
                Loader.open();
                user = await Backend.call("/?path=/prospects&branch=" + Service.branch,
                    {
                        name: data.nome.replace(nome[nome.length - 1], "").toUpperCase(),
                        email: data.email,
                        cellphone: data.telefone,
                        lastName: nome[nome.length - 1].toUpperCase(),
                        cpf: data.cpf,
                        tokenGympass: data.tokenGympass || null,
                    });
                if (typeof user !== "undefined" && user.hasOwnProperty('idProspect')) {
                    user = [user];
                }
                Loader.close();
            }
            data.user = user;
            data.userData = {
                name: data.nome.replace(nome[nome.length - 1], "").toUpperCase(),
                email: data.email,
                cellphone: data.telefone,
                lastName: nome[nome.length - 1],
                cpf: data.cpf,
            };
            let experimental = await Service.scheduleClass(data);
            if (!experimental || experimental.hasOwnProperty("errors")) {
                console.log("um erro aconteceu");
                return false;
            }
            console.log("aula agendada com sucesso!");
            return experimental;
        }
    },
    getUnidades: () => {
        if (Service.unidades.length > 0) {
            return Service.unidades;
        }
        (async () => {
            let response = await Backend.call("/?path=get-unidades&branch=CIDADES");
            Service.unidades = response;
        })();
    },
    getModalides: () => {
        return modalidades;
    },
    getParams: () => {
        let parameterList = new URLSearchParams(window.location.search)
        if (parameterList.size > 0 && parameterList.get('regiao')) {
            let params = parameterList.get('regiao');
            return params.split(",");
        }
        return false
    },
    getSource: () => {
        let parameterList = new URLSearchParams(window.location.search)
        if (parameterList.size > 0) {
            return parameterList.get('source');
        }
        return null
    }
}

Service.getUnidades();
